const getJustify = justify => {
  let formattedJustify;

  switch (justify) {
    case 'Start':
      formattedJustify = 'flex-start';
      break;
    case 'Left':
      formattedJustify = 'flex-start';
      break;
    case 'Center':
      formattedJustify = 'center';
      break;
    case 'End':
      formattedJustify = 'flex-end';
      break;
    case 'Right':
      formattedJustify = 'flex-end';
      break;
    case 'Space Around':
      formattedJustify = 'space-around';
      break;
    case 'Space Between':
      formattedJustify = 'space-between';
      break;
  }

  return formattedJustify;
};

export default getJustify;
